module.exports = __webpack_public_path__ + "media/images/logo3-2f4ea95aebcbfbeb0d16bf32317dfd74.png";